import React, { Component } from "react";
import { Button, Modal, FormControl, FormGroup } from "react-bootstrap";
import { fire, auth } from "../../firebase/index";
import {
  customLog,
  deploymentEnvironment,
  style,
} from "../../variables/Variables";
import ReactGA from "react-ga";
import RedemptionSample from "../Tutorial/RedemptionSample";
import {
  downgradePlan,
  convertEpochToDMY,
  prorationCalculation,
  validationMessage,
  proratedPlan,
  overridePlan,
  updateRedemptionCodeDatabase,
  redeemPlanEmail,
  validate30DaysPolicy,
} from "./RedemptionHelper";
import LocalizedStrings from "react-localization";
import { ClipLoader } from "react-spinners";
import ipapi from "ipapi.co";
import NotificationSystem from "react-notification-system";
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
let localizationStrings = new LocalizedStrings({
  en: {
    redemptionTitle:
      "The following eGeeTouch Account will be used for redemption",
    accountName: "Account Name",
    accountEmail: "Account Email",
    accountCompany: "Account Company",
    enterRedemption: "Enter Product Key",
    warningText:
      " If the above email is incorrect, please sign out and redeem using the correct eGeeTouch Account",
    validateCode: "Validate Code",
    redeem: "Redeem",
    learnMore: "Learn more about Product Keys and see examples",
    noRedemptionMessage:
      "*No Product Key? Select the Subscription Plans' tab above to continue with alternative subscription methods",
  },
  ja: {
    redemptionTitle:
      "eGeeTouchインテリジェントアクセス管理システム用アカウント",
    accountName: "アカウント名",
    accountEmail: "アカウントEメール",
    accountCompany: "企業名・グループ名等",
    enterRedemption: "16桁のプロダクトキーを入力",
    warningText:
      " メールアドレスを誤って入力した場合は、サインアウトしてから、正しいアドレスを入力してください。",
    validateCode: "プロダクトキーの検証",
    redeem: "申込み",
    learnMore: "プロダクトキーについて",
    noRedemptionMessage:
      "プロダクトキーをお持ちでない場合、「サブスクリプション」からクレジットカード決済でお申込みできます。",
  },
  es: {
    redemptionTitle:
      "La siguiente cuenta de eGeeTouch se utilizará para el canje",
    accountName: "Nombre de la Cuenta",
    accountEmail: "Correo Electrónico de la Cuenta",
    accountCompany: "Empresa de la Cuenta",
    enterRedemption: "Ingrese la Clave del Producto",
    warningText:
      " Si el correo electrónico anterior es incorrecto, cierre sesión y canjee utilizando la cuenta correcta de eGeeTouch",
    validateCode: "Validar Código",
    redeem: "Canjear",
    learnMore: "Aprenda más sobre las Claves de Producto y vea ejemplos",
    noRedemptionMessage:
      "*¿No tiene Clave de Producto? Seleccione la pestaña de Planes de Suscripción arriba para continuar con métodos alternativos de suscripción",
  },
});
const override = {
  display: "block",
};

var trackerID = "";
if (deploymentEnvironment) {
  //! Live
  trackerID = "G-7D4M74VB11";
} else {
  //! Test
  trackerID = "G-LWK1V2E1FE";
}

class Redemption extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userDetail: [],
      userPayment: [],
      nextPlanDetail: [],
      currentPlanDetail: [],
      proratedPlanDetail: [],
      userExistingPackage: "",
      inputRedemptionCode1: "",
      inputRedemptionCode2: "",
      inputRedemptionCode3: "",
      inputRedemptionCode4: "",
      redemptionPackage: [],
      validateCodePackage: {},
      sameRedemptionPackage: null,
      redemptionCodeExist: false,
      redemptionCodeValidation: false,
      pendingPlanExist: false,
      redemptionCode: "",
      _notificationSystem: null,
      validationMessageCode: 0,
      showLearnMorePopup: false,
      showProratePopup: false,
      prorationPopupTitle: "",
      learnMorePopupTitle: "",
      learnMorePopupImage: [],
      loading: false,
      conditionButton: "",
      countryCode: "",
      show30DaysPolicyWarning: false,
      recommendedDate: [],
    };

    this.handleInputCode1 = this.handleInputCode1.bind(this);
    this.handleInputCode2 = this.handleInputCode2.bind(this);
    this.handleInputCode3 = this.handleInputCode3.bind(this);
    this.handleInputCode4 = this.handleInputCode4.bind(this);
    this.validateCode = this.validateCode.bind(this);
    this.thirtyDaysValidation = this.thirtyDaysValidation.bind(this);
    this.redeemCode = this.redeemCode.bind(this);
    this.prorateCode = this.prorateCode.bind(this);
    this.overrideCode = this.overrideCode.bind(this);
    this.toInputUppercase = this.toInputUppercase.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.handleLearnMorePopupClose = this.handleLearnMorePopupClose.bind(this);
    this.handleLearnMorePopup = this.handleLearnMorePopup.bind(this);
    this.handleProrationPopup = this.handleProrationPopup.bind(this);
    this.handleProrationPopupClose = this.handleProrationPopupClose.bind(this);
    // this.downgradeCode = this.downgradeCode.bind(this);
    this.handle30DaysWarningPopup = this.handle30DaysWarningPopup.bind(this);
    this.handle30DaysWarningPopupClose = this.handle30DaysWarningPopupClose.bind(
      this
    );
    this.handleForceRedeem = this.handleForceRedeem.bind(this);

    this.textInput1 = React.createRef();
    this.textInput2 = React.createRef();
    this.textInput3 = React.createRef();
    this.textInput4 = React.createRef();
  }
  componentWillMount() {
    //? Check if user have existing plan.
    ipapi.location(async (callback) => {
      if (callback.country_code === "JP") {
        customLog(callback.country_code);
        this.setState({
          countryCode: callback.country_code,
        });
      } else if (callback.country_code === "GB") {
        customLog(callback.country_code);
        this.setState({
          countryCode: callback.country_code,
        });
      }
    });

    fire
      .database()
      .ref("registeredIndustrialUsersOnPlatform")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        this.setState({
          userDetail: snapshot.val(),
        });
      })
      .then(() => {
        customLog(this.state.userDetail);
      });

    let userCurrentPackage = "";
    const userExistingRedemption = {};

    const groupAccountPaymentDB = fire
      .database()
      .ref("groupAccounts")
      .child(auth.currentUser.uid)
      .child("payment");

    groupAccountPaymentDB
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          var snapshotVal = snapshot.val();
          const redeemCodeList = snapshotVal.redeemedRedemptionCode;
          if (snapshotVal.plan === 1) {
            userCurrentPackage = "STARTER";
          } else if (snapshotVal.plan === 2) {
            userCurrentPackage = "ESSENTIAL";
          } else if (snapshotVal.plan === 3) {
            userCurrentPackage = "PROFESSIONAL";
          } else if (snapshotVal.plan === 4) {
            userCurrentPackage = "CUSTOM";
          } else if (snapshotVal.plan === 6) {
            userCurrentPackage = "ENTRY_STARTER";
          } else if (snapshotVal.plan === 7) {
            userCurrentPackage = "LOCK_FOCUS";
          } else if (snapshotVal.plan === 8) {
            userCurrentPackage = "PRO_LOCK";
          } else if (snapshotVal.plan === 9) {
            userCurrentPackage = "USER_FOCUS";
          } else if (snapshotVal.plan === 10) {
            userCurrentPackage = "PRO_USER";
          }

          this.setState({
            userPayment: snapshotVal,
            userExistingPackage: userCurrentPackage,
          });

          for (const i in redeemCodeList) {
            if (redeemCodeList[i].status === "pending") {
              this.setState({
                pendingPlanExist: true,
              });
            }
          }
        }
      })
      .then(() => {
        customLog(this.state.userPayment);
      });

    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  showNotification(msg, lvl, dismissal, allowDismiss) {
    let dismissalAllowed = false;

    if (allowDismiss === "") {
      dismissalAllowed = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: dismissal,
      dismissible: dismissalAllowed,
    });
  }

  toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  handleInputCode1(code, field) {
    if (code.target.value.length === 4) {
      field.current.nextSibling.nextSibling.focus();
      this.setState({
        inputRedemptionCode1: code.target.value,
      });
    }
  }
  handleInputCode2(code, field) {
    if (code.target.value.length === 4) {
      field.current.nextSibling.nextSibling.focus();
      this.setState({
        inputRedemptionCode2: code.target.value,
      });
    }
  }
  handleInputCode3(code, field) {
    if (code.target.value.length === 4) {
      field.current.nextSibling.nextSibling.focus();
      this.setState({
        inputRedemptionCode3: code.target.value,
      });
    }
  }
  handleInputCode4(code, field) {
    if (code.target.value.length === 4) {
      this.setState({
        inputRedemptionCode4: code.target.value,
      });
    }
  }

  async thirtyDaysValidation() {
    await validate30DaysPolicy(async (callback) => {
      if (callback.validation) {
        //! if callback TRUE meaning the last redeem date was or more than 30days ago
        //! PRORATION
        if (this.state.conditionButton === "PRORATE") {
          this.handleProrationPopup();
        } else if (this.state.conditionButton === "EXTEND") {
          this.redeemCode();
        }
      } else {
        //! if callback FALSE meaning the last redeem date was within the 30days
        //! OVERRIDE
        //! show policy warning message
        await this.setState({
          show30DaysPolicyWarning: true,
          recommendedDate: callback,
        });
        customLog(callback);
      }
    });
  }

  async handleForceRedeem() {
    //! By Force Redeeming mean override the existing code
    //TODO change redeemCOde to OverrideCode
    // console.log("Override code processing");
    this.overrideCode();
  }

  async validateCode(e) {
    e.preventDefault();
    await this.setState({
      loading: true,
    });

    const inputRedemptionCode =
      this.state.inputRedemptionCode1 +
      this.state.inputRedemptionCode2 +
      this.state.inputRedemptionCode3 +
      this.state.inputRedemptionCode4;

    customLog("INPUT CODE (" + inputRedemptionCode + ")");
    const currentTimeStamp = Math.floor(Date.now() / 1000);
    const userPaymentValid = this.state.userPayment.isPaymentValid;
    const userActiveRedemption = this.state.userPayment
      .currentRedemptionActiveCode;
    const userPaymentType = this.state.userPayment.currentPaymentType;

    var BreakException = {};

    try {
      fire
        .database()
        .ref("redemptionCodes")
        .once("value")
        .then((snapshot) => {
          let redemptionPlanDetail = {};
          snapshot.forEach((redemptionCodes) => {
            redemptionCodes.forEach((eachCode) => {
              //! check if the entered code is empty or not
              if (inputRedemptionCode !== "") {
                //! check if the code exist
                if (inputRedemptionCode === eachCode.key) {
                  //! check if the code have been redeem before
                  if (eachCode.val().redeemed !== true) {
                    if (eachCode.val().Plan === 1) {
                      redemptionPlanDetail = {
                        package: "STARTER",
                        plan: 1,
                        maxLocks: 50,
                        maxTags: 50,
                        maxUsers: 20,
                        maxMulti: 4,
                      };
                    } else if (eachCode.val().Plan === 2) {
                      redemptionPlanDetail = {
                        package: "ESSENTIAL",
                        plan: 2,
                        maxLocks: 100,
                        maxTags: 100,
                        maxUsers: 40,
                        maxMulti: 4,
                      };
                    } else if (eachCode.val().Plan === 3) {
                      redemptionPlanDetail = {
                        package: "PROFESSIONAL",
                        plan: 3,
                        maxLocks: 500,
                        maxTags: 200,
                        maxUsers: 100,
                        maxMulti: 8,
                      };
                    } else if (eachCode.val().Plan === 4) {
                      redemptionPlanDetail = {
                        package: "CUSTOM",
                        plan: 4,
                        maxLocks: eachCode.val().maxLocks,
                        maxTags: eachCode.val().maxTags,
                        maxUsers: eachCode.val().maxUsers,
                        maxMulti: eachCode.val().maxMulti,
                      };
                    } else if (eachCode.val().Plan === 6) {
                      redemptionPlanDetail = {
                        package: "ENTRY_STARTER",
                        plan: 6,
                        maxLocks: 5,
                        maxTags: 4,
                        maxUsers: 4,
                        maxMulti: 1,
                      };
                    } else if (eachCode.val().Plan === 7) {
                      redemptionPlanDetail = {
                        package: "LOCK_FOCUS",
                        plan: 7,
                        maxLocks: 25,
                        maxTags: 10,
                        maxUsers: 10,
                        maxMulti: 2,
                      };
                    } else if (eachCode.val().Plan === 8) {
                      redemptionPlanDetail = {
                        package: "PRO_LOCK",
                        plan: 8,
                        maxLocks: 300,
                        maxTags: 75,
                        maxUsers: 25,
                        maxMulti: 4,
                      };
                    } else if (eachCode.val().Plan === 9) {
                      redemptionPlanDetail = {
                        package: "USER_FOCUS",
                        plan: 9,
                        maxLocks: 4,
                        maxTags: 30,
                        maxUsers: 40,
                        maxMulti: 2,
                      };
                    } else if (eachCode.val().Plan === 10) {
                      redemptionPlanDetail = {
                        package: "PRO_USER",
                        plan: 10,
                        maxLocks: 10,
                        maxTags: 100,
                        maxUsers: 180,
                        maxMulti: 4,
                      };
                    }
                    //! user current active redemption code exist (user redeem before)
                    if (userPaymentValid) {
                      if (
                        userActiveRedemption !== "" &&
                        userActiveRedemption !== null &&
                        userActiveRedemption !== undefined
                      ) {
                        if (
                          redemptionPlanDetail.plan ===
                          this.state.userPayment.plan
                        ) {
                          this.setState({
                            redemptionPackage: eachCode.val(),
                            validateCodePackage: redemptionPlanDetail,
                            redemptionCodeExist: true,
                            sameRedemptionPackage: true,
                            redemptionCode: inputRedemptionCode,
                            validationMessageCode: 1,
                            loading: false,
                            conditionButton: "EXTEND",
                          });
                          customLog("Same Redemption Plan");
                        } else {
                          //! user not allow to prorate to a custom plan
                          if (redemptionPlanDetail.package !== "CUSTOM") {
                            fire
                              .database()
                              .ref("subscriptionPackageDetail")
                              .child(redemptionPlanDetail.package)
                              .once("value")
                              .then((snapshot) => {
                                if (snapshot.exists()) {
                                  this.setState({
                                    nextPlanDetail: snapshot.val(),
                                  });
                                }
                              });

                            fire
                              .database()
                              .ref("subscriptionPackageDetail")
                              .child(this.state.userExistingPackage)
                              .once("value")
                              .then((snapshot) => {
                                if (snapshot.exists()) {
                                  this.setState({
                                    currentPlanDetail: snapshot.val(),
                                  });
                                }
                              });
                          }
                          this.setState({
                            redemptionPackage: eachCode.val(),
                            validateCodePackage: redemptionPlanDetail,
                            redemptionCodeExist: true,
                            sameRedemptionPackage: false,
                            redemptionCode: inputRedemptionCode,
                            validationMessageCode: 2,
                            loading: false,
                            conditionButton: "PRORATE",
                          });
                          customLog("Different Redemption Plan");
                        }
                      }
                    } else {
                      //! user current active redemption code do not exist (new user)

                      this.setState({
                        redemptionPackage: eachCode.val(),
                        validateCodePackage: redemptionPlanDetail,
                        redemptionCodeExist: true,
                        redemptionCode: inputRedemptionCode,
                        validationMessageCode: 1,
                        loading: false,
                        conditionButton: "REDEEM",
                      });
                      customLog("New Redemption Plan");
                    }
                  } else {
                    //! Entered code had been redeem before
                    this.setState({
                      validationMessageCode: 3,
                      redemptionCodeExist: false,
                      loading: false,
                    });
                  }
                  //? this throw is to get out of the loop
                  throw BreakException;
                } else {
                  //! Entered code not vaild
                  this.setState({
                    validationMessageCode: 5,
                    redemptionCodeExist: false,
                    loading: false,
                  });
                }
              } else {
                //! Entered code is empty
                this.setState({
                  validationMessageCode: 4,
                  redemptionCodeExist: false,
                  loading: false,
                });
              }
            });
          });
        })
        .then(() => {
          customLog(this.state.redemptionPackage);
          customLog(this.state.validateCodePackage);
          customLog(this.state.nextPlanDetail);
          customLog(this.state.currentPlanDetail);
        });
    } catch (e) {
      if (e !== BreakException) {
        throw e;
      }
    }
  }

  async redeemCode() {
    const codeExist = this.state.redemptionCodeExist;
    const validCode = this.state.redemptionCode;
    const validCodePackagePlan = this.state.validateCodePackage.package;
    const validCodePackageDetail = this.state.validateCodePackage;
    var formattedValidCode = validCode.substring(0, 4);

    const dataToPost = {
      packageName: validCodePackagePlan,
      redemptionCode: formattedValidCode,
      uid: auth.currentUser.uid,
      email: auth.currentUser.email,
    };

    if (codeExist) {
      // fire
      //   .database()
      //   .ref("redemptionCodes")
      //   .child(validCodePackage)
      //   .child(validCode)
      //   .once("value")
      //   .then(snapshot => {
      //     customLog(snapshot.val());
      //   });

      //24*60*60 = 86400 (1 day)
      const oneYearInSecond = 31536000;
      const redeemedDate = Math.floor(Date.now() / 1000);
      const redemptionEndDate = redeemedDate + oneYearInSecond;

      let groupAccountDB = fire
        .database()
        .ref("groupAccounts")
        .child(auth.currentUser.uid);

      const pushKey = groupAccountDB
        .child("payment")
        .child("redeemedRedemptionCode")
        .push().key;

      const dbPayments = {
        isPaymentValid: true,
        maxUsers: validCodePackageDetail.maxUsers,
        maxTags: validCodePackageDetail.maxTags,
        maxLocks: validCodePackageDetail.maxLocks,
        maxMulti: validCodePackageDetail.maxMulti,
        plan: validCodePackageDetail.plan,
        currentPaymentType: "REDEMPTION",
        currentRedemptionActiveCode: validCode,
        startedOn: redeemedDate,
        endedOn: redemptionEndDate,
        lastUpdated: redeemedDate,
      };

      const dbGroupMembers = {
        isAdmin: true,
        isSuperAdmin: true,
        memberAddedOn: redeemedDate,
        memberEmail: auth.currentUser.email,
        memberUid: "push.key",
      };

      const groupAccSchema = {
        created_on: redeemedDate,
        groupName: "My First Group",
        payment: dbPayments,
      };

      const updateRedemptionCodeFirebaseData = {
        validCodePackagePlan: validCodePackagePlan,
        validCode: validCode,
        redeemedDate: redeemedDate,
      };

      await updateRedemptionCodeDatabase(
        updateRedemptionCodeFirebaseData,
        async (callback) => {
          if (callback) {
            //! UPDATE groupAccounts payment
            //! Check if user groupAccount exist or not

            groupAccountDB
              .once("value")
              .then((snapshot) => {
                //! if groupAccount exist
                if (snapshot.exists()) {
                  customLog("Redemption: Existing User");
                  if (
                    snapshot.val().payment.redeemedRedemptionCode === null ||
                    snapshot.val().payment.redeemedRedemptionCode === undefined
                  ) {
                    customLog(
                      "Redemption: Existing User but NEVER REDEEM BEFORE"
                    );
                    //! existing user but NEVER REDEEM BEFORE

                    groupAccountDB
                      .child("payment")
                      .update({
                        isPaymentValid: true,
                        maxUsers: validCodePackageDetail.maxUsers,
                        maxTags: validCodePackageDetail.maxTags,
                        maxLocks: validCodePackageDetail.maxLocks,
                        maxMulti: validCodePackageDetail.maxMulti,
                        plan: validCodePackageDetail.plan,
                        currentPaymentType: "REDEMPTION",
                        currentRedemptionActiveCode: validCode,
                        endedOn: redemptionEndDate,
                        startedOn: redeemedDate,
                        lastUpdated: redeemedDate,
                      })
                      .then(async () => {
                        await groupAccountDB
                          .child(
                            "payment/" + "redeemedRedemptionCode/" + pushKey
                          )
                          .update({
                            redeemedDate: redeemedDate,
                            redemptionCode: validCode,
                            redeemedEndTime: redemptionEndDate,
                            redeemedStartTime: redeemedDate,
                            maxUsers: validCodePackageDetail.maxUsers,
                            maxTags: validCodePackageDetail.maxTags,
                            maxLocks: validCodePackageDetail.maxLocks,
                            maxMulti: validCodePackageDetail.maxMulti,
                            status: "active",
                            plan: validCodePackageDetail.plan,
                          });
                      });
                  } else {
                    customLog("Redemption: Existing User and REDEEM BEFORE");
                    //! existing user and REDEEM BEFORE

                    groupAccountDB
                      .child("payment")
                      .once("value")
                      .then(async (snapshot) => {
                        const firstEndDateSecondStartDate = snapshot.val()
                          .endedOn;
                        const updateRedemptionEndDate =
                          snapshot.val().endedOn + oneYearInSecond;

                        await groupAccountDB
                          .child("payment")
                          .update({
                            isPaymentValid: true,
                            maxUsers: validCodePackageDetail.maxUsers,
                            maxTags: validCodePackageDetail.maxTags,
                            maxLocks: validCodePackageDetail.maxLocks,
                            maxMulti: validCodePackageDetail.maxMulti,
                            plan: validCodePackageDetail.plan,
                            currentPaymentType: "REDEMPTION",
                            // currentRedemptionActiveCode: validCode,
                            endedOn: updateRedemptionEndDate,
                            lastUpdated: redeemedDate,
                          })
                          .then(async () => {
                            await groupAccountDB
                              .child(
                                "payment/" + "redeemedRedemptionCode/" + pushKey
                              )
                              .update({
                                redeemedDate: redeemedDate,
                                redemptionCode: validCode,
                                redeemedEndTime: updateRedemptionEndDate,
                                redeemedStartTime: firstEndDateSecondStartDate,
                                maxUsers: validCodePackageDetail.maxUsers,
                                maxTags: validCodePackageDetail.maxTags,
                                maxLocks: validCodePackageDetail.maxLocks,
                                maxMulti: validCodePackageDetail.maxMulti,
                                status: "pending",
                                plan: validCodePackageDetail.plan,
                              });
                          });
                      });
                  }
                } //! if new user
                else {
                  customLog("Redemption: New User");
                  groupAccountDB.set(groupAccSchema).then(async () => {
                    const today = new Date();

                    const groupMembersKey = groupAccountDB
                      .child("members")
                      .push(dbGroupMembers).key;

                    await groupAccountDB
                      .child("members/" + groupMembersKey)
                      .update({
                        memberUid: groupMembersKey,
                        memberEmail: auth.currentUser.email,
                        memberAddedOn: today.getTime(),
                      });

                    const randomKey = groupAccountDB.child("groupID").push()
                      .key;

                    await groupAccountDB.child("groupID").set(randomKey);

                    await groupAccountDB
                      .child("payment/" + "redeemedRedemptionCode/" + pushKey)
                      .update({
                        redeemedDate: redeemedDate,
                        redemptionCode: validCode,
                        redeemedEndTime: redemptionEndDate,
                        redeemedStartTime: redeemedDate,
                        maxUsers: validCodePackageDetail.maxUsers,
                        maxTags: validCodePackageDetail.maxTags,
                        maxLocks: validCodePackageDetail.maxLocks,
                        maxMulti: validCodePackageDetail.maxMulti,
                        status: "active",
                        plan: validCodePackageDetail.plan,
                      });
                  });
                }
              })
              .then(async () => {
                await this.showNotification(
                  "Redeem Redemption Code Successful!",
                  "success",
                  3
                );

                await redeemPlanEmail(dataToPost, async (callback) => {
                  if (callback) {
                    await setTimeout(() => {
                      window.location.href = "/dashboard";
                    }, 1000);
                  }
                });
              });
          } else {
            this.showNotification(
              "Something went wrong!. Please Try again!",
              "error",
              3
            );
          }
        }
      );
    }
  }

  async prorateCode() {
    //! Upgrade Plan
    const codeExist = this.state.redemptionCodeExist;
    const validCode = this.state.redemptionCode;
    const validCodePackagePlan = this.state.validateCodePackage.package;
    const validCodePackageDetail = this.state.validateCodePackage;
    var formattedValidCode = validCode.substring(0, 4);
    const proratedEndDate = this.state.proratedPlanDetail
      .proratedPlanEndDateInSec;

    const dataToPost = {
      packageName: validCodePackagePlan,
      redemptionCode: formattedValidCode,
      uid: auth.currentUser.uid,
      email: auth.currentUser.email,
    };

    const oneYearInSecond = 31536000;
    const redeemedDate = Math.floor(Date.now() / 1000);
    const proratedAndRedeemEndDate = proratedEndDate + oneYearInSecond;

    const updateRedemptionCodeFirebaseData = {
      validCodePackagePlan: validCodePackagePlan,
      validCode: validCode,
      redeemedDate: redeemedDate,
    };

    const proratePlanData = {
      validateCodePackage: this.state.validateCodePackage.package,
      currentRedemptionActiveCode: this.state.redemptionCode,
      maxLocks: this.state.nextPlanDetail.maxLocks,
      maxMulti: this.state.nextPlanDetail.maxMulti,
      maxTags: this.state.nextPlanDetail.maxTags,
      maxUsers: this.state.nextPlanDetail.maxUsers,
      plan: this.state.nextPlanDetail.plan,
      proratedEndDate: proratedEndDate,
      proratedAndRedeemEndDate: proratedAndRedeemEndDate,
      validCode: validCode,
      redeemedDate: redeemedDate,
    };

    await proratedPlan(proratePlanData, async (callback) => {
      if (callback) {
        await updateRedemptionCodeDatabase(
          updateRedemptionCodeFirebaseData,
          async (callback) => {
            if (callback) {
              await this.showNotification(
                "Proration Successful!",
                "success",
                3
              );

              await this.showNotification(
                "Redeem Redemption Code Successful!",
                "success",
                3
              );

              await redeemPlanEmail(dataToPost, async (callback) => {
                if (callback) {
                  await setTimeout(() => {
                    window.location.href = "/dashboard";
                  }, 1000);
                }
              });
            }
          }
        );
      } else {
        customLog("Proration Failed");
      }
    });
  }

  async overrideCode() {
    const codeExist = this.state.redemptionCodeExist;
    const validCode = this.state.redemptionCode;
    var formattedValidCode = validCode.substring(0, 4);
    const validCodePackagePlan = this.state.validateCodePackage.package;
    const validCodePackageDetail = this.state.validateCodePackage;
    const userPaymentDetail = this.state.userPayment;

    let overrideData = {
      validCode: validCode,
      validCodePackageDetail: validCodePackageDetail,
      userPaymentDetail: userPaymentDetail,
      conditionButton: this.state.conditionButton,
    };

    const emailData = {
      packageName: validCodePackagePlan,
      redemptionCode: formattedValidCode,
      uid: auth.currentUser.uid,
      email: auth.currentUser.email,
    };

    const updateFirebaseCodeData = {
      validCodePackagePlan: validCodePackagePlan,
      validCode: validCode,
      redeemedDate: Math.floor(Date.now() / 1000),
    };

    if (codeExist) {
      await overridePlan(overrideData, async (callback) => {
        if (callback) {
          await updateRedemptionCodeDatabase(
            updateFirebaseCodeData,
            async (callback) => {
              if (callback) {
                await this.showNotification(
                  "Redeem Redemption Code Successful!",
                  "success",
                  3
                );
              } else {
                await this.showNotification(
                  "Something went wrong!. Please Try again!",
                  "error",
                  3
                );
              }
            }
          );
        } else {
          await this.showNotification(
            "Something went wrong!. Please Try again!",
            "error",
            3
          );
        }
        await redeemPlanEmail(emailData, async (callback) => {
          if (callback) {
            await setTimeout(() => {
              window.location.href = "/dashboard";
            }, 1000);
          }
        });
      });
    }
  }

  //! DOWNGRADE PLAN
  // async downgradeCode() {
  //   console.log("downgrading plan..");
  //   const validCode = this.state.redemptionCode;
  //   var formattedValidCode = validCode.substring(0, 4);
  //   const validCodePackagePlan = this.state.validateCodePackage.package;

  //   const updateRedemptionCodeData = {
  //     validCodePackagePlan: validCodePackagePlan,
  //     validCode: validCode,
  //     redeemedDate: Math.floor(Date.now() / 1000)
  //   };

  //   const dataToPost = {
  //     packageName: validCodePackagePlan,
  //     redemptionCode: formattedValidCode,
  //     uid: auth.currentUser.uid,
  //     email: auth.currentUser.email
  //   };

  //   const downgradeData = {
  //     validateCodePackage: validCodePackagePlan,
  //     maxLocks: this.state.nextPlanDetail.maxLocks,
  //     maxMulti: this.state.nextPlanDetail.maxMulti,
  //     maxTags: this.state.nextPlanDetail.maxTags,
  //     maxUsers: this.state.nextPlanDetail.maxUsers,
  //     plan: this.state.nextPlanDetail.plan,
  //     validCode: this.state.redemptionCode
  //   };

  //   await downgradePlan(downgradeData, async callback => {
  //     if (callback) {
  //       await updateRedemptionCodeDatabase(
  //         updateRedemptionCodeData,
  //         async callback => {
  //           if (callback) {
  //             await this.showNotification(
  //               "Redeem Redemption Code Successful!",
  //               "success",
  //               3
  //             );

  //             await redeemPlanEmail(dataToPost, async callback => {
  //               if (callback) {
  //                 await setTimeout(() => {
  //                   window.location.href = "/dashboard";
  //                 }, 1000);
  //               }
  //             });
  //           }
  //         }
  //       );
  //     } else {
  //       this.showNotification(
  //         "Something went wrong!. Please Try again!",
  //         "error",
  //         3
  //       );
  //     }
  //   });
  // }

  handle30DaysWarningPopup() {
    this.setState({
      show30DaysPolicyWarning: true,
    });
  }

  handle30DaysWarningPopupClose() {
    this.setState({
      show30DaysPolicyWarning: false,
    });
  }

  handleLearnMorePopup() {
    this.setState({
      showLearnMorePopup: true,
      learnMorePopupTitle: "Examples",
      learnMorePopupImage: [<RedemptionSample />],
    });
  }

  handleLearnMorePopupClose() {
    this.setState({ showLearnMorePopup: false });
  }

  handleProrationPopup() {
    var calculateProration = {};

    this.setState({
      showProratePopup: true,
      prorationPopupTitle: "Proration Calculation",
    });

    if (this.state.countryCode === "JP") {
      calculateProration = {
        currentPlanAnnualPrice: this.state.currentPlanDetail.planPriceAnnualJP,
        nextPlanAnnualPrice: this.state.nextPlanDetail.planPriceAnnualJP,
        currentTimeStamp: Math.floor(Date.now() / 1000),
        currentPlanStartDate: this.state.userPayment.startedOn,
        currentPlanEndDate: this.state.userPayment.endedOn,
      };
    } else if (this.state.countryCode === "GB") {
      calculateProration = {
        currentPlanAnnualPrice: this.state.currentPlanDetail.planPriceAnnualUK,
        nextPlanAnnualPrice: this.state.nextPlanDetail.planPriceAnnualUK,
        currentTimeStamp: Math.floor(Date.now() / 1000),
        currentPlanStartDate: this.state.userPayment.startedOn,
        currentPlanEndDate: this.state.userPayment.endedOn,
      };
    } else {
      calculateProration = {
        currentPlanAnnualPrice: this.state.currentPlanDetail.planPriceAnnual,
        nextPlanAnnualPrice: this.state.nextPlanDetail.planPriceAnnual,
        currentTimeStamp: Math.floor(Date.now() / 1000),
        currentPlanStartDate: this.state.userPayment.startedOn,
        currentPlanEndDate: this.state.userPayment.endedOn,
      };
    }

    this.setState({
      proratedPlanDetail: prorationCalculation(calculateProration),
    });
    customLog(prorationCalculation(calculateProration));
  }

  handleProrationPopupClose() {
    this.setState({ showProratePopup: false });
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <h3>{localizationStrings.redemptionTitle}</h3>
        <br />
        <table className="redeemPageTable">
          <tbody>
            <tr>
              <th>{localizationStrings.accountName}:</th>
              <th>{this.state.userDetail.name}</th>
            </tr>
            <tr>
              <th>{localizationStrings.accountEmail}:</th>
              <th>{this.state.userDetail.email}</th>
            </tr>
            <tr>
              <th>{localizationStrings.accountCompany}:</th>
              <th>{this.state.userDetail.company}</th>
            </tr>
          </tbody>
        </table>
        <br />
        <h5>{localizationStrings.warningText}</h5>
        <p>
          <a href="#" onClick={this.handleLearnMorePopup}>
            <u>{localizationStrings.learnMore}</u>
          </a>
        </p>
        <b>{localizationStrings.enterRedemption}</b>
        <form>
          <div className="flex">
            <div className="flex" class="redemptionCodeInput">
              <input
                className="redeemCodeInput"
                name={this.textInput1}
                ref={this.textInput1}
                maxLength="4"
                onChange={(e) => this.handleInputCode1(e, this.textInput1)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
                required
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput2}
                ref={this.textInput2}
                maxLength="4"
                onChange={(e) => this.handleInputCode2(e, this.textInput2)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
                required
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput3}
                ref={this.textInput3}
                maxLength="4"
                onChange={(e) => this.handleInputCode3(e, this.textInput3)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
                required
              />
              <div className="horizontalShortLine"></div>
              <input
                className="redeemCodeInput"
                name={this.textInput4}
                ref={this.textInput4}
                maxLength="4"
                onChange={(e) => this.handleInputCode4(e, this.textInput4)}
                onInput={this.toInputUppercase}
                placeholder="XXXX"
                required
              />
              <button className="validateBtn" onClick={this.validateCode}>
                <a
                  href="#"
                  style={{ color: "white" }}
                  // onClick={() => {
                  //   ReactGA.event(
                  //     {
                  //       category: "validate code",
                  //       action: "card redemption",
                  //       value: 1
                  //     },
                  //     [trackerID]
                  //   );
                  // }}
                >
                  {localizationStrings.validateCode}
                </a>
              </button>
            </div>
          </div>
        </form>
        <br />
        {!this.state.loading ? (
          <div>
            <div>
              <p
                style={{
                  display: this.state.redemptionCodeExist ? "block" : "none",
                  color:
                    this.state.validationMessageCode === 1 ||
                    this.state.validationMessageCode === 2
                      ? "green"
                      : "red",
                }}
              >
                {this.state.validationMessageCode === 2
                  ? validationMessage(1)
                  : validationMessage(this.state.validationMessageCode)}
              </p>
              <p
                style={{
                  display:
                    this.state.redemptionCodeExist === true &&
                    this.state.sameRedemptionPackage === false &&
                    this.state.validationMessageCode === 2
                      ? "block"
                      : "none",
                  color: "orange",
                }}
              >
                {validationMessage(2)}
              </p>
            </div>

            <table
              className="redeemPageTable"
              style={{
                display: this.state.redemptionCodeExist ? "block" : "none",
              }}
            >
              <tbody>
                <tr>
                  <th>Subscription Package:</th>
                  <th>{this.state.validateCodePackage.package}</th>
                </tr>
                <tr>
                  <th>Padlock:</th>
                  <th>{this.state.validateCodePackage.maxLocks}</th>
                </tr>
                <tr>
                  <th>User Accounts:</th>
                  <th>{this.state.validateCodePackage.maxUsers}</th>
                </tr>
                <tr>
                  <th>Layer of Multi Approval:</th>
                  <th>{this.state.validateCodePackage.maxMulti}</th>
                </tr>
              </tbody>
            </table>
            <br />

            {/* <div>
              {this.state.conditionButton === "REDEEM" ? (
                <button className="redeemBtn" onClick={this.redeemCode}>
                  {localizationStrings.redeem}
                </button>
              ) : this.state.conditionButton === "UPGRADE" &&
                this.state.userPayment.isPaymentValid === true ? (
                <button
                  className="prorateBtn"
                  onClick={this.handleProrationPopup}
                >
                  Upgrade Plan
                </button>
              ) : this.state.conditionButton === "DOWNGRADE" &&
                this.state.userPayment.isPaymentValid === true &&
                this.state.pendingPlanExist === false ? (
                <button
                  className="prorateBtn"
                  onClick={this.handle30DaysWarningPopup}
                >
                  Downgrade Plan
                </button>
              ) : this.state.pendingPlanExist === true ? (
                <p
                  style={{
                    color: "red"
                  }}
                >
                  {validationMessage(6)}
                </p>
              ) : (
                ""
              )}
            </div> */}

            <div>
              {this.state.conditionButton === "REDEEM" ? (
                //! New User
                <button className="redeemBtn" onClick={this.redeemCode}>
                  {/* onClick={this.thirtyDaysValidation} */}
                  {localizationStrings.redeem}
                </button>
              ) : this.state.conditionButton === "PRORATE" &&
                this.state.userPayment.isPaymentValid === true &&
                this.state.pendingPlanExist === false ? (
                //! User with redemption code but different code in comparsion wiht the entered code
                <button
                  className="prorateBtn"
                  // onClick={this.handleProrationPopup}
                  onClick={this.thirtyDaysValidation}
                >
                  Prorate Plan
                </button>
              ) : this.state.conditionButton === "EXTEND" &&
                this.state.userPayment.isPaymentValid === true &&
                this.state.pendingPlanExist === false ? (
                //! User with redemption code and same code in comparsion with the entered code
                <button
                  className="redeemBtn"
                  onClick={this.thirtyDaysValidation}
                >
                  {localizationStrings.redeem}
                </button>
              ) : this.state.pendingPlanExist === true &&
                this.state.userPayment.isPaymentValid === true &&
                this.state.redemptionCodeExist === true ? (
                <p
                  style={{
                    color: "red",
                  }}
                >
                  {validationMessage(6)}
                </p>
              ) : (
                ""
              )}
            </div>

            <p
              style={{
                marginTop: "20px",
                display: this.state.redemptionCodeExist ? "none" : "block",
              }}
            >
              {localizationStrings.noRedemptionMessage}
            </p>
          </div>
        ) : (
          <div>
            <ClipLoader
              css={override}
              size={150}
              color={"#a9a9a9"}
              loading={this.state.loading}
            />
          </div>
        )}
        <Modal
          show={this.state.showLearnMorePopup}
          onHide={this.handleLearnMorePopupClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.learnMorePopupTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{this.state.learnMorePopupImage}</Modal.Body>
        </Modal>
        <Modal
          show={this.state.showProratePopup}
          onHide={this.handleProrationPopupClose}
          // dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.prorationPopupTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.userExistingPackage === "CUSTOM" ||
            this.state.validateCodePackage.package === "CUSTOM" ? (
              <div>
                <h6>
                  Your Current or Prorated plan is a CUSTOM package, Which is a
                  special plan.
                </h6>
                <h6>Please contact the support team for help.</h6>
              </div>
            ) : (
              <div>
                <table>
                  <tbody>
                    <tr>
                      <th>Current Plan Package:</th>
                      <th>{this.state.userExistingPackage}</th>
                    </tr>
                    <tr>
                      <th>Current Plan Duration Left:</th>
                      <th>
                        {this.state.proratedPlanDetail.currentPlanDuration +
                          " days"}
                      </th>
                    </tr>
                    <tr>
                      <th>Current Plan End Date:</th>
                      <th>
                        {this.state.proratedPlanDetail.currentPlanEndDate}
                      </th>
                    </tr>
                  </tbody>
                </table>

                <hr />
                <h5>
                  We have calculated the prorated plan details based on the
                  Product Key (
                  {this.state.inputRedemptionCode1 +
                    " - " +
                    this.state.inputRedemptionCode2 +
                    " - " +
                    this.state.inputRedemptionCode3 +
                    " - " +
                    this.state.inputRedemptionCode4}
                  ) you have entered.
                </h5>
                <hr />
                <table>
                  <tbody>
                    <tr>
                      <th>Prorated Plan Package:</th>
                      <th>{this.state.validateCodePackage.package}</th>
                    </tr>
                    <tr>
                      <th>Prorated Plan Duration Adjustment:</th>
                      <th>
                        {this.state.proratedPlanDetail.proratedPlanDuration +
                          " days"}
                      </th>
                    </tr>
                    <tr>
                      <th>Prorated Plan End Date:</th>
                      <th>
                        {this.state.proratedPlanDetail.proratedPlanEndDate}
                      </th>
                    </tr>
                  </tbody>
                </table>
                <hr />
                <h5>
                  Your Redemption product key will start on{" "}
                  <u>{this.state.proratedPlanDetail.proratedPlanEndDate}</u>
                  <br /> and end on{" "}
                  <u>
                    {this.state.proratedPlanDetail.proratedAndRedeemEndDate}
                  </u>
                </h5>
                <hr />
                <button
                  className="prorateBtn"
                  style={{ width: "100%" }}
                  onClick={this.prorateCode}
                >
                  Confirm Proration & Redeem Product Key
                </button>
                <h5>
                  *You are not required to made any payment for prorating your
                  current plan.
                </h5>
              </div>
            )}
          </Modal.Body>
        </Modal>

        {/* <Modal
          show={this.state.showDowngradePopup}
          onHide={this.handle30DaysWarningPopupClose}
        >
          <Modal.Body>
            <h3 style={{ textAlign: "center" }}>
              Are you sure you want to downgrade your current subscription plan
            </h3>
            <div className="flex">
              <Button
                style={{ color: "black", backgroundColor: "orange" }}
                onClick={this.downgradeCode}
              >
                Yes, Redeem the product key
              </Button>
              <Button
                style={{ color: "white", backgroundColor: "red" }}
                onClick={this.handle30DaysWarningPopupClose}
              >
                {" "}
                No, Save the product key
              </Button>
            </div>
            <br />
            <p style={{ textAlign: "center", color: "grey" }}>
              You can use your current subscription plan until{" "}
              <u>{convertEpochToDMY(this.state.userPayment.endedOn)}</u>
              <br />
              before you can use this downgraded subscription plan.
            </p>
          </Modal.Body>
        </Modal> */}

        <Modal
          show={this.state.show30DaysPolicyWarning}
          onHide={this.handle30DaysWarningPopupClose}
        >
          <Modal.Header style={{ backgroundColor: "orange", color: "black" }}>
            <Modal.Title>Cooldown Warning!</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <h3 style={{ textAlign: "center" }}>
             
              <br />
              You are recommended to redeem your new product key on [DATE] to
              recieved the benenfit of the prorated plan. This prorated plan
              will provided you an increase/decrease on the current plan
              duration based on your new product key.
              <br />
            
            </h3> */}

            {/* <div className="flex">
              <Button
                style={{ color: "black", backgroundColor: "orange" }}
                onClick={this.downgradeCode}
              >
                Yes, Redeem the product key
              </Button>
              <Button
                style={{ color: "white", backgroundColor: "red" }}
                onClick={this.handle30DaysWarningPopupClose}
              >
                {" "}
                No, Save the product key
              </Button>
            </div> */}

            <p style={{ color: "black" }}>
              You had recently redeemed your product key. Therefore, you had a
              30 days cooldown before you are recommended to redeem another
              product key.
            </p>

            <p style={{ color: "darkgreen" }}>
              You are highly recommended to redeem your new product key on{" "}
              <br />
              <u>{this.state.recommendedDate.redeemCodeAfterOneMonth}</u> which
              is {this.state.recommendedDate.daysAways} days away.
            </p>

            <p style={{ color: "red" }}>
              By Force Redeeming your new product now. You would lose benefit of
              prorating your current subscription plan!
            </p>

            <div className="flex">
              <Button
                style={{ color: "black", backgroundColor: "orange" }}
                onClick={() => {
                  window.location.reload();
                }}
              >
                Wait for Recommended Date
              </Button>
              <Button
                style={{ color: "white", backgroundColor: "red" }}
                onClick={this.handleForceRedeem}
              >
                Force Redeem
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
export default Redemption;
